import { LoadingOutlined } from "@ant-design/icons";
import cn from "classnames";
import Link from "next/link";
import { CSSProperties, ReactElement, ReactNode } from "react";

const ButtonComp = ({
    href,
    disabled,
    onClick,
    style,
    className,
    children,
}: {
    children: ReactNode;
    className?: string;
    disabled?: boolean;
    style?: CSSProperties;
    onClick?: () => void;
    href?: string;
}) => {
    if (disabled || onClick || !href) {
        return (
            <button style={style} className={className} disabled={disabled} onClick={onClick}>
                {children}
            </button>
        );
    } else {
        return (
            <Link style={style} className={className} href={href}>
                {children}
            </Link>
        );
    }
};

const Button = ({
    children,
    className,
    type = "default",
    onClick,
    style,
    icon: passedIcon,
    disabled: passedDisabled = false,
    loading = false,
    href,
}: {
    children: ReactNode;
    className?: string;
    type?: "default" | "primary";
    onClick?: () => void;
    icon?: ReactElement;
    style?: CSSProperties;
    disabled?: boolean;
    loading?: boolean;
    href?: string;
}) => {
    const disabled = !!loading || passedDisabled;
    const icon = loading ? <LoadingOutlined /> : passedIcon;

    return (
        <ButtonComp
            disabled={disabled}
            onClick={onClick}
            style={style}
            href={href}
            className={cn(
                "flex items-center button h-8 text-nowrap",
                {
                    "button-primary": type === "primary",
                    "button-disabled": disabled,
                },
                className
            )}
        >
            {icon && <div className="pr-2">{icon}</div>}
            <div className="flex-grow text-center">{children}</div>
        </ButtonComp>
    );
};

export default Button;
